import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../utils/PropTypesDefinitions'
import BigButton from '../../BaseComponents/Button/Standard/Big'
import HorizontalSpacer from '../../Layouts/Spacer/Horizontal'

export type FeedbackButtonsProps = {
    /**
     *  callback when first button was clicked
     *
     *  @TJS-type function
     */
    onPressFirst: () => void
    /**
     *  callback when second button was clicked
     *
     *  @TJS-type function
     */
    onPressSecond: () => void
    /**
     *  text of first button
     */
    textFirst: string
    /**
     *  text of second button
     */
    textSecond: string
} & TestID

const FeedbackButtons: FunctionComponent<FeedbackButtonsProps> = ({
    onPressFirst,
    onPressSecond,
    textFirst,
    textSecond,
    testID,
}) => (
    <Grid noExpand height={60} horizontal centerVertical testID={testID}>
        <Grid>
            <BigButton backgroundColor="moon-2" onPress={onPressFirst} expand>
                {textFirst}
            </BigButton>
        </Grid>
        <HorizontalSpacer space="standard" />
        <Grid>
            <BigButton backgroundColor="onyx" onPress={onPressSecond} expand>
                {textSecond}
            </BigButton>
        </Grid>
    </Grid>
)

export default FeedbackButtons
